module.exports = __webpack_public_path__ + "img/bom-icon4.3c414da3.png";